import { ChainIdEnum } from "../../../enums/chain";
import { ChainConfig } from "../types";
import { DEFAULT_TOKEN_DECIMALS, MARGINX_BRANDING } from "./shared";

// ============================================
// OPTIMISM (Chain ID: 10)
// ============================================
export const optimismConfig: ChainConfig = {
  chainId: ChainIdEnum.OPTIMISM,
  name: "OP Mainnet",
  shortName: "optimism",
  isTestnet: false,
  rpcUrls: ["https://mainnet.optimism.io"],
  explorerUrl: "https://optimistic.etherscan.io",
  l2ExplorerUrl: "https://basecamp.cloud.blockscout.com",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  tokenDecimals: DEFAULT_TOKEN_DECIMALS,
  contracts: {
    erc20: {
      usdc: "0x7F5c764cBc14f9669B88837ca1490cCa17c31607",
      "usdc-native": "0x0b2c639c533813f4aa9d7837caf62653d097ff85",
      usdt: "",
      weth: "0x4200000000000000000000000000000000000006",
      wbtc: "",
      l2usdc: "0x643aaB1618c600229785A5E06E4b2d13946F7a1A",
      l2usdt: "",
      l2weth: "0xB9D571c1EC576300f01ddfA5A082D9c571E45e36",
      l2wbtc: "",
      govToken: "",
    },
    multichain: {
      socketHelper: "0xe49dee5353bea74caf65089237005198a14f7c83",
      vault: {
        usdc: "0xFff4A34925301d231ddF42B871c3b199c1E80584",
        "native-usdc": "0x7809621a6D7e61E400853C64b61568aA773A28Ef",
        weth: "0x5c7Dd6cb73d93879E94F20d103804C495A10aE7e",
      },
      connector: {
        usdc: "0x1812ff6bd726934f18159164e2927B34949B16a8",
        "native-usdc": "0xF0A0B2E99D081Ee737496DAD5E2267ab12139793",
        weth: "0xeCaa2435d99c4987876A0382F1661dBf539700C0",
      },
      withdrawalConnector: {
        usdc: "0x7b9ed5C43E87DAFB03211651d4FA41fEa1Eb9b3D",
        "native-usdc": "0x0c0Ed11E55EFF4bb8324e2497e6CA34FD2D87f67",
        weth: "0x48B4f0692eaA84F1961b64342Ae746D40d9ac2F2",
      },
      l2WithdrawProxy: "0xE3EF8bEE5c378D4D3DB6FEC96518e49AE2D2b957",
    },
  },
  signingDomain: { name: "MarginX Mainnet", version: "1" },
  socketL2ChainId: 2999,
  branding: MARGINX_BRANDING,
};
